import { ICalendarEvent, ICalendarEventPart, ICalendarRenderProps, ISidebarRouteState } from 'components';
import { StageState, UpdateState } from 'enums';
import React from 'react';
import { IHomeCalendarData } from '../Home';
import { CalendarLink } from './CalendarLink';
import { renderCounts } from './renderCounts';
import { renderBar } from './renderBar';
import { renderIcon } from './renderIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TFunction } from 'i18next';
import { getEventLabel } from './getEventLabel';
import { getEventTitle } from './getEventTitle';

export function renderEvent(
    { key, ...otherPropsFromCalendar }: ICalendarRenderProps,
    event: ICalendarEvent<IHomeCalendarData>,
    eventPart: ICalendarEventPart<IHomeCalendarData>,
    routeState: ISidebarRouteState,
    timezone: string,
    t: TFunction
) {
    const data = event.isGroupGap ? event.groupGapPrevEvent.data : event.data;
    const update = data.update;
    const stage = data.stage;
    const prevStage = update.rollout.stages?.[data.stageIndex - 1];
    // The stage is only ready for confirmation if the previous stage has already started.
    const canConfirmStage = update.state === UpdateState.Running
        && stage.state === StageState.Scheduled
        && stage.requiresConfirmation
        && !stage.isConfirmed
        && prevStage
        && (prevStage.state === StageState.Running || prevStage.state === StageState.Done);

    // Only show bar and icon at the start of an event.
    const showBarAndIcon = eventPart.isStartInRow && eventPart.isFirstPartOfEvent;
    const label = getEventLabel(event);
    const title = getEventTitle(event, timezone);

    return <CalendarLink
        canConfirmStage={canConfirmStage}
        isGroupGap={event.isGroupGap}
        key={key}
        propsFromCalendar={otherPropsFromCalendar}
        routeState={routeState}
        stage={stage}
        title={title}
        update={update}
    >
        {!event.isGroupGap && <>
            {showBarAndIcon && renderBar(update, stage)}
            {!canConfirmStage && <>
                {showBarAndIcon && renderIcon(update, stage)}
                <div className="calendarUpdateEvent_label ellipsis">
                    {label}
                </div>
                {renderCounts(event)}
            </>}
            {/* If the stage requies confirmation, we're animating the label to alternate between the default label,
                and a message saying that the stage needs confirmation. */}
            {canConfirmStage && <>
                <div className="calendarUpdateEvent_animatedLabelWrap">
                    <div className="calendarUpdateEvent_animatedLabel1">
                        {showBarAndIcon && renderIcon(update, stage)}
                        <span className="calendarUpdateEvent_label ellipsis">
                            {label}
                        </span>
                        {renderCounts(event)}
                    </div>
                    <div className="calendarUpdateEvent_animatedLabel2">
                        <FontAwesomeIcon icon="exclamation-triangle" className="calendarUpdateEvent_stateIcon" />
                        <div className="ellipsis">
                            {t('home.stageNeedsConfirm')}
                        </div>
                    </div>
                </div>
            </>}
           
        </>}
    </CalendarLink>
}